module.exports = __webpack_public_path__ + "img/bg-logo-blue-full.aa3a4628.svg";